import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridSelectionOptions } from '@epicor/kinetic';
declare var $: any;
import { IEpBtCardControlModel, BistrackConfig } from 'ep-bt-controls';
import { Router, ActivatedRoute } from '@angular/router';
import { FieldAgentClient, ProductPriceDetails, Product, ProductSellPriceBand, PagingParameters, SortParameters, GetProductPurchasesByAllCustomersRequest, } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-selling-bands-grid',
  templateUrl: './epbt-fa-product-selling-bands-grid.component.html',
  styleUrls: ['./epbt-fa-product-selling-bands-grid.component.scss']
})
export class EpbtFaProductSellingBandsGridComponent implements OnInit {

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 10;
  public cards: Array<IEpBtCardControlModel>;

  @ViewChild(EpGridComponent, { static: false }) grid: EpGridComponent;
  @ViewChild('sellPriceTemplate', { static: true }) sellPriceTemplate: TemplateRef<any>;
  @ViewChild('actualPriceTemplate', { static: true }) actualPriceTemplate: TemplateRef<any>;
  @ViewChild('discount1PercentageTemplate', { static: true }) discount1PercentageTemplate: TemplateRef<any>;
  @ViewChild('discount2PercentageTemplate', { static: true }) discount2PercentageTemplate: TemplateRef<any>;
  @ViewChild('gPPercentageTemplate', { static: true }) gPPercentageTemplate: TemplateRef<any>;

  @Input() selectedProductItem: any;
  webTrackUser: any;
  productPurchasedbyRequest: GetProductPurchasesByAllCustomersRequest;
  paging: PagingParameters;
  sort: SortParameters;
  webtrackResult: any;
  currency: string;
  bisTrackSettings: any;
  prod: any;
  minValue = -2147483648;
  productPriceDetails: ProductPriceDetails;
  result: number;

  constructor(private client: FieldAgentClient, private route: ActivatedRoute, private router: Router,
    private fieldAgentService: EpbtFieldAgentService,
    private config: BistrackConfig) { }

  ngOnInit() {
    // console.log("Selling bands grid:selectedProductItem:" + JSON.stringify(this.selectedProductItem));
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.currency = bistrackSettings.baseCurrency.symbol;
      this.pageSize = bistrackSettings.searchPageSize;
    });
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });
    this.bindGridData();
    this.gridModel = this.getGridModel();
  }


  // grid height calculation start
  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 440; }// return 500;
  }
  // grid height calculation end


  // grid model start
  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'bandNumber',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      columns: [
        { field: 'bandNumber', title: 'PRICE BAND', width: 30, hidden: false },
        { field: 'type', title: 'TYPE', width: 30, hidden: false },
        { field: 'name', title: 'NAME', width: 30, hidden: false },
        { field: 'description', title: 'DESCR', width: 40, hidden: false },
        { field: 'calculationTypeDescription', title: 'CALC.TYPE', width: 30, hidden: false },
        { field: 'sellPrice', title: 'SELL PRICE', width: 30, hidden: false, cellTemplate: this.sellPriceTemplate },
        { field: 'actualPrice', title: 'ACT.PRICE', width: 30, hidden: false, cellTemplate: this.actualPriceTemplate },
        { field: 'perName', title: 'UOM', width: 30, hidden: false },
        { field: 'discount1', title: 'DISC./MARKUP 1', width: 30, hidden: false, cellTemplate: this.discount1PercentageTemplate },
        { field: 'discount2', title: 'DISC./MARKUP 2', width: 40, hidden: false, cellTemplate: this.discount2PercentageTemplate },
        { field: 'calculatedGP', title: 'CALC.GP%', width: 30, hidden: false, cellTemplate: this.gPPercentageTemplate },
      ]
    };
    return model;
  }
  // grid model end


  bindGridData() {
    this.listDataSource((priceBandsRes: ProductSellPriceBand[]) => {
      let priceBands: Array<ProductSellPriceBand> = [];
      priceBands = priceBandsRes;
      this.prod = this.selectedProductItem;

      // Gateway is using @ReturnAsSelect parameter of [GetProductPriceDetails] SP to return one row of data
      this.client.getProductPricing(this.prod.productId, this.webTrackUser.webTrackTradingBranch.branchID).subscribe(res => {
        if (res != null && res.length > 0) {
          let productPricing: Array<ProductPriceDetails> = [];
          productPricing = res;
          this.productPriceDetails = new ProductPriceDetails();
          this.productPriceDetails = productPricing[0];
        }
        priceBands.forEach(sb => {
          if (sb.perId == 0) {
            sb.perId = 1;
          }
          this.updateSellPriceBand(sb, this.prod, this.productPriceDetails);
        });
        this.gridModel.data = priceBands;
      });
    });
  }

  updateSellPriceBand(sellingBand: ProductSellPriceBand, product: Product, productPriceDetails: ProductPriceDetails): void {
    let sellPrice: number; let actualPrice: number; let GP: number;
    this.getPriceBandSellPrice(sellingBand, product, productPriceDetails, (sellPrice: number) => {
      sellPrice = sellPrice;
      actualPrice = this.getPriceAfterDiscount(sellPrice, sellingBand.discount1, sellingBand.discount2, sellingBand.discount1Type, sellingBand.discount2Type);
      sellingBand.sellPrice = sellPrice;
      sellingBand.actualPrice = actualPrice;
      GP = this.calculateGP(sellingBand, product, productPriceDetails);
      sellingBand.calculatedGP = GP;
    });
  }

  calculateGP(sellBand: ProductSellPriceBand, prod: Product, productPricing: ProductPriceDetails): number {
    let GP: number; let averageCostWithAdd: number; let sellPrice: number; let perConversion: number; let averageCostPerId: number; let sellPerID: number;
    averageCostWithAdd = productPricing.averageCostWithAdd == 0 ? productPricing.companyAverageCostWithAdd : productPricing.averageCostWithAdd;
    averageCostPerId = productPricing.averageCostPerId == 0 ? productPricing.companyAverageCostPerId : productPricing.averageCostPerId;
    sellPerID = sellBand.perId;
    sellPrice = sellBand.actualPrice;
    perConversion = 1;
    if (sellPerID != 0 || averageCostPerId != 0) {
      if (sellPrice > 0 && averageCostWithAdd > 0) {
        if (sellPerID != averageCostPerId) {
          this.getPerConversion(sellPerID, averageCostPerId, prod.productId, prod.imperial, prod.thickness, prod.width, prod.length, prod.weight, (perConversion: number) => {
            perConversion = perConversion;
          });
        }
        if (perConversion != 0) {
          averageCostWithAdd = averageCostWithAdd * perConversion;
          GP = ((sellPrice - averageCostWithAdd) / sellPrice);
        }
      }
    }
    return GP;
  }

  getPerConversion(fromPerID: number, toPerID: number, productId: number, imperial: boolean, thickness: number, width: number, length: number, weight: number,
    subscribe: (perConversion: number) => void) {
    let perConversion: number;
    this.client.getPerConversion(fromPerID, toPerID, productId, imperial, thickness, width, length, weight).subscribe(res => {
      if (res != null) {
        perConversion = res;
      }
      subscribe(perConversion);
    });
  }

  getPriceAfterDiscount(priceBeforeDiscountVal: number, discount1Val: number, discount2Val: number, discount1Type: number, discount2Type: number): number {
    let result, temp, priceBeforeDiscount, discount1, discount2;
    const roundDiscountDown = true; // for now

    priceBeforeDiscount = parseFloat(priceBeforeDiscountVal.toFixed(4));
    discount1 = parseFloat(discount1Val.toFixed(2));
    discount2 = parseFloat(discount2Val.toFixed(2));

    // Apply 1st discount
    if (discount1Type == 0) {
      if (roundDiscountDown) {
        const calValue1 = priceBeforeDiscount * (discount1 / 100);
        temp = this.roundValue(calValue1, 2);
      } else {
        const calValue2 = priceBeforeDiscount * (discount1 / 100);
        temp = this.roundValue(calValue2, 1); // Round Up
      }
    } else {
      if (roundDiscountDown) {
        temp = this.roundValue(discount1, 2);
      } else {
        temp = this.roundValue(discount1, 1);
      }// Round Up
    }

    // Apply 2nd discount
    if (discount2Type == 0) {
      if (roundDiscountDown) {
        const Value1 = priceBeforeDiscount + temp + (priceBeforeDiscount + temp) * (discount2 / 100);
        result = this.roundValue(Value1, 2);
      } else {
        const Value2 = priceBeforeDiscount + temp + (priceBeforeDiscount + temp) * (discount2 / 100);
        result = this.roundValue(Value2, 1); // Round Up
      }
    } else {
      // Amount
      if (roundDiscountDown) {
        const Value3 = priceBeforeDiscount + temp + discount2;
        result = this.roundValue(Value3, 2);
      } else {
        const Value4 = priceBeforeDiscount + temp + discount2;
        result = this.roundValue(Value4, 1); // Round Up
      }
    }
    return result;
  }

  getPriceBandSellPrice(sellBand: ProductSellPriceBand, prod: Product, productPricing: ProductPriceDetails,
    subscribe: (sellPrice: number) => void) {
    let sellPrice: number;
    this.client.getProductPricing(prod.productId, sellBand.branchId).subscribe(priceBandsRes => {
      if (priceBandsRes != null && priceBandsRes.length > 0) {
        let branchProductPricings: Array<ProductPriceDetails> = [];
        this.productPriceDetails = new ProductPriceDetails();
        branchProductPricings = priceBandsRes;
        this.productPriceDetails = branchProductPricings[0];
        switch (sellBand.sellPriceCalculationType) {
          case 0: {
              sellPrice = sellBand.sellPrice;
              break;
            }
          case 1: {
              sellPrice = productPricing.standardSellPrice;
              break;
            }
          case 2: {
              sellPrice = productPricing.averageCostWithAdd;
              break;
            }
          case 3: {
              sellPrice = productPricing.lastCostWithAdd;
              break;
            }
          case 4: {
              sellPrice = productPricing.standardBuyPrice;
              break;
            }
          default:
            sellPrice = 0;
            break;
        }
      }
      subscribe(sellPrice);
    });
  }

  listDataSource(subscribe: (priceBands: ProductSellPriceBand[]) => void) {
    this.client.getProductSellPriceBands(this.webTrackUser.bisTrackUserId, this.selectedProductItem.productId).subscribe(res => {
      subscribe(res);
    });
  }

  roundValue(value, precision) {
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }
}
